/** @jsx createElementEntity */
import { createElementEntity } from "../utils/jsx-entity";
import WomanModelSrc from "../assets/models/animations/women.glb";
import ManModelSrc from "../assets/models/animations/man.glb";
import WomanIdleSrc from "../assets/models/animations/female-idle-animation.glb";
import ManIdleSrc from "../assets/models/animations/male-idle-animation.glb";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

function loadGLB(url: string):Promise<GLTF> {
  const loader = new GLTFLoader();
  return new Promise((resolve, reject) => {
    loader.load(url, (gltf2: GLTF) => {
    resolve(gltf2);
    }, undefined, reject);
  });
};

let womanModel: any;
let manModel: any;
let womanIdle:any;
let manIdle: any;
export async function loadAnimationModel() {
  // model = ((await loadModel(modelSrc, null, false))).scene;
  const gltfWoman = await loadGLB(WomanModelSrc);
  womanModel = gltfWoman.scene;
  womanModel.animations = gltfWoman.animations;

  const gltfMan = await loadGLB(ManModelSrc);
  manModel = gltfMan.scene;
  manModel.animations = gltfMan.animations;

  const womanIdleGltf = await loadGLB(WomanIdleSrc);
  womanIdle = womanIdleGltf.scene;
  womanIdle.animations = womanIdleGltf.animations;

  const manIdleGltf = await loadGLB(ManIdleSrc);
  manIdle = manIdleGltf.scene;
  manIdle.animations = manIdleGltf.animations;
}

export function animationModel() {
  return <entity name="animations">
    <entity name="Female Animation" object3D={womanModel}></entity>
    <entity name="Male Animation" object3D={manModel}></entity>
    <entity name="Female Animation Idle" object3D={womanIdle}></entity>
    <entity name="Male Animation Idle" object3D={manIdle}></entity>
  </entity>;
}
